import request from '@utils/request'
import { ParamsProps, ReturnType } from './types'

const find = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `admins/${args.id}`,
      method: 'get',
      authorization: true,
      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: 'set',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}
const login = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: 'admins/login',
      method: 'post',
      data: args?.data,
      authorization: false,
      config: {
        showErr: true,
        successMsg: 'Login Successfully.',
      },
    }
    const response = await request(config)

    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

const logout = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: 'admins/logout',
      method: 'post',
      authorization: true,
      data: args?.data,
      config: {
        successMsg: 'Logout Successfully.',
        showErr: true,
        store: {
          key: 'user',
          action: 'reset',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

const changePassword = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: 'admins/change-password',
      method: 'patch',
      data: args?.data,
      authorization: true,
      config: {
        showErr: true,
        successMsg: 'Password changed successfully',
        store: {
          action: 'update',
          key: 'admin',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}
const create = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: 'admins',
      method: 'post',
      data: args?.data,
      authorization: true,
      config: {
        showErr: true,
        successMsg: 'sub-admin created successfully',
        store: {
          key: args?.state,
          action: 'prepend',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}

const subadmin = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `admins`,
      method: 'get',
      authorization: true,
      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: 'set',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}
const remove = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `admins/${args?.id}`,
      method: 'delete',
      authorization: true,
      config: {
        successMsg: 'deleted successfully',
        showErr: true,
        store: {
          key: args?.state,
          action: 'remove',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

export default { find, login, changePassword, logout, create, subadmin, remove }
